<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!-- main -->
    <b-row>
      <b-col lg="12">
        <!-- 查询条件 -->
        <b-card>
          <b-row>
            <b-col lg="4">
              <b-form-group
                label="Code"
                label-cols-sm="4"
                label-align-sm="right"
              >
                <b-form-input
                  v-model="search_condition.code"
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col lg="4">
              <b-form-group
                label="Status"
                label-cols-sm="4"
                label-align-sm="right"
              >
                <b-form-select
                  v-model="search_condition.status"
                  id="cartridge-type"
                  :options="types.statuss"
                  value-field="value"
                  text-field="text"
                >
                </b-form-select>
              </b-form-group>
            </b-col>

            <b-col lg="4">
              <b-button variant="primary" @click="search()">Search</b-button>
            </b-col>
          </b-row>
        </b-card>

        <b-card>
          <!-- table -->
          <b-button
            v-has="'RecommenderCode::Create'"
            @click="gotoAdd"
            variant="primary"
            >Create</b-button
          >
          <div class="table-responsive mb-0">
            <b-table
              show-empty
              empty-text="no records"
              id="device-table"
              head-variant="light"
              ref="table"
              :busy="isBusy"
              :striped="true"
              :items="provider"
              :fields="fields"
              :per-page="search_condition.pageSize"
              :current-page="search_condition.pageNum"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-includedfields="filterOn"
              @filtered="onFiltered"
            >
              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>

              <template v-slot:cell(index)="data">{{
                data.index +
                (search_condition.pageNum - 1) * search_condition.pageSize +
                1
              }}</template>

              <template v-slot:cell(actions)="row">
                <b-button-group>
                  <b-button
                    v-has="'RecommenderCode::Modify'"
                    size="sm"
                    variant="info"
                    @click="edit(row.item, row.index, $event.target)"
                    class="mr-1"
                    >Modify</b-button
                  >

                  <b-button
                    v-if="!row.item.status"
                    v-has="'RecommenderCode::Disable'"
                    size="sm"
                    variant="danger"
                    @click="enableOrDisable(row.item, row.index, $event.target)"
                    class="mr-1"
                  >
                    Disable
                  </b-button>

                  <b-button
                    v-else
                    v-has="'RecommenderCode::Enable'"
                    size="sm"
                    variant="info"
                    @click="enableOrDisable(row.item, row.index, $event.target)"
                    class="mr-1"
                  >
                    Enable
                  </b-button>

                  <!-- <b-button
                    size="sm"
                    variant="danger"
                    @click="del(row.item, row.index, $event.target)"
                    class="mr-1"
                    >del</b-button
                  > -->
                </b-button-group>
              </template>
            </b-table>
          </div>
          <!-- end table -->
          <!-- pagination -->
          <b-row v-if="has_data">
            <b-col>
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination mb-0" v-if="rows != 0">
                  <b-pagination
                    ref="page"
                    v-model="search_condition.pageNum"
                    :per-page="10"
                    :total-rows="rows"
                    aria-controls="table"
                  ></b-pagination>
                </ul>
              </div>
            </b-col>
          </b-row>
          <!-- end pagination -->
        </b-card>
      </b-col>
    </b-row>
    <!-- end main -->
  </Layout>
</template>
<script>
import DatePicker from "vue2-datepicker";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import timeZoneConversion from "@/components/widgets/timeZoneConversion";

export default {
  components: {
    DatePicker,
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Recommender Code",
      items: [
        {
          text: "UNI-CORE",
          // href: "/"
        },
        {
          text: "Content Mgmt",
          // href: "/"
        },
        {
          text: "Recommender Code",
          active: true,
        },
      ],
      tableData: [],
      totalRows: 0,
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: false,
      fields: [
        { key: "index", label: "#", class: "text-center" },
        { key: "code", label: "Code", class: "text-center" },
        {
          key: "status",
          label: "Status",
          class: "text-center",
          formatter: (value) => {
            return value == 0 ? "enable" : "disable";
          },
        },
        {
          key: "failureState",
          label: "Failure State",
          class: "text-center",
          formatter: (value) => {
            return value == 1 ? "Permanent" : "Have a time limit";
          },
        },
        {
          key: "createTime",
          label: "Create Time",
          class: "text-center",
          formatter: (value) => {
            if (value) {
              return timeZoneConversion.getLocalTime(value);
            } else {
              return "";
            }
          },
        },
        { key: "actions", label: "Opreration", class: "text-center" },
      ],
      search_condition: {
        pageNum: 1,
        pageSize: 10,
        code: "",
        status: "",
        // supplierId: localStorage.supplierId,
      },
      isBusy: false,
      has_data: false,
      types: {
        statuss: [
          { text: "Please select", value: "", disabled: false },
          { text: "enable", value: 0, disabled: false },
          { text: "disable", value: 1, disabled: false },
        ],
      },
    };
  },
  watch: {},
  computed: {
    /**
     * 计算rows
     */
    rows() {
      return this.totalRows;
    },
  },
  mounted() {},
  methods: {
    provider(ctx) {
      this.isBusy = true;
      return this.$api.RecommenderCode.list(this.search_condition, ctx)
        .then((x) => {
          this.isBusy = false;
          if (x.total) {
            this.has_data = true;
            this.totalRows = x.total;
            return x.data;
          } else {
            this.has_data = false;
            return [];
          }
        })
        .catch((e) => {
          this.isBusy = false;
          this.has_data = false;
          return [];
        });
    },
    search() {
      this.search_condition.pageNum = 1;
      this.$refs.table.refresh();
      //this.$bvToast.toast(JSON.stringify(this.search_condition));
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.search_condition.pageNum = 1;
    },
    gotoAdd() {
      this.$router.push("recommenderCodeAdd");
    },
    show(item, index, button) {
      this.$router.push("RecommenderCodeInfo?id=" + item.id);
    },
    edit(item, index, button) {
      this.$router.push({
        name: "healthManage/recommenderCodeEdit",
        params: item,
      });
    },
    enableOrDisable(a, b, c) {
      this.$api.RecommenderCode.enableOrDisable({
        id: a.id,
        status: a.status === 0 ? 1 : 0,
      }).then((res) => {
        if (res.message) {
          this.$bvToast.toast(res.message);
        }
        if (res.success) {
          this.$refs.table.refresh();
        }
      });
    },
  },
};
</script>
